import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import SEOMeta from '@/components/base/SEOMeta';
import JsonLd from '@/components/base/JsonLd';
import CategoryTabs from '@/components/feature/CategoryTabs';
import ArticleCard from '@/components/feature/ArticleCard';
import { categories } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';
import NotFound from '@/pages/NotFound';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  if (!category || !slug) {
    return <NotFound />;
  }

  const articles = getArticlesByCategory(slug);

  return (
    <>
      <ScrollToTop />
      <SEOMeta
        title={`${category.name} - 逼特逼视频内容分类`}
        description={category.description}
        keywords={`逼特逼视频,${category.name},逼特逼视频内容,逼特逼视频${category.name}频道`}
      />
      <JsonLd type="Organization" />
      <JsonLd type="WebSite" />
      <JsonLd
        type="WebPage"
        pageTitle={`${category.name} - 逼特逼视频内容分类`}
        pageDescription={category.description}
        pageUrl={`https://www.bitbivideo.com/category/${slug}`}
      />
      <JsonLd
        type="BreadcrumbList"
        breadcrumbs={[
          { name: '首页', url: 'https://www.bitbivideo.com' },
          { name: category.name, url: `https://www.bitbivideo.com/category/${slug}` },
        ]}
      />

      <Navbar />
      <Breadcrumb />

      <main>
        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className={`${category.icon} text-2xl md:text-3xl text-primary-600`}></i>
              </div>
              <div>
                <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                  {category.name}
                </h1>
                <p className="text-sm text-foreground-600 mt-1">
                  {category.description}
                </p>
              </div>
            </div>

            <CategoryTabs activeSlug={slug} />

            <div className="mt-8">
              {articles.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                  {articles.map((article) => (
                    <ArticleCard key={article.slug} article={article} />
                  ))}
                </div>
              ) : (
                <div className="text-center py-20">
                  <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
                    <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground-700 mb-2">
                    暂无相关内容
                  </h3>
                  <p className="text-sm text-foreground-500 mb-6">
                    该分类下暂时没有文章，请浏览其他分类
                  </p>
                  <Link
                    to="/"
                    className="inline-flex items-center gap-1.5 px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors duration-200"
                  >
                    <i className="ri-home-line"></i>
                    返回首页
                  </Link>
                </div>
              )}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}